import React, { useState } from 'react';

import { Accordion, Icon, List } from 'semantic-ui-react';

import _isEmpty from 'lodash/isEmpty';
import { useSelector } from 'react-redux';

import { ModifierSetPropType } from 'components/modules/catalog/proptypes/catalog';
import { selectBusinessModifiers } from 'selectors/catalog';

import EditMenuItemModifierSet from '../EditMenuItemModifierSet/EditMenuItemModifierSet';

const propTypes = {
  modifierSet: ModifierSetPropType,
};

const defaultProps = {
  modifierSet: {},
};

export default function MenuItemModifierSet({
  modifierSet,
  active,
  onClick,
  itemIndex,
  itemId,
  index,
  onCreate,
  onRemoveMenuItemModifier: onRemoveMenuItemModifierProp,
}) {
  const {
    id,
    name,
    minAllowed,
    maxAllowed,
    modifiers: modifierSetModifierIds = [],
  } = modifierSet || {};

  const isNew = !id;

  const [showModal, setShowModal] = useState(isNew);

  const allModifiers = useSelector(selectBusinessModifiers);

  function openModal() {
    setShowModal(true);
  }

  function closeModal() {
    setShowModal(false);
  }

  function onRemoveMenuItemModifier(e) {
    e.stopPropagation();
    onRemoveMenuItemModifierProp(id);
  }

  function getModifierSetModifiers() {
    if (!_isEmpty(modifierSet)) {
      return allModifiers
        .map((modifier, modifierIndex) => ({ ...modifier, index: modifierIndex }))
        .filter(
          ({ id: modifierId, localId: modifierLocalId }) =>
            modifierSetModifierIds.includes(modifierId) ||
            modifierSetModifierIds.includes(modifierLocalId),
        );
    }
    return [];
  }

  const showMin = !Number.isNaN(parseInt(minAllowed, 10)) && parseInt(minAllowed, 10) > 0;
  const showMax = !Number.isNaN(parseInt(maxAllowed, 10)) && parseInt(maxAllowed, 10) > 0;

  const modifierSetModifiers = getModifierSetModifiers();

  return (
    <>
      <Accordion.Title className="modifier-set-title" active={active} onClick={onClick}>
        <Icon name="dropdown" />
        <div>
          <span>{name}</span>
          {showMin && <span className="limit-tag">Min: {minAllowed}</span>}
          {showMax && <span className="limit-tag">Max: {maxAllowed}</span>}
          <span
            onClick={onRemoveMenuItemModifier}
            style={{ marginRight: '1rem', textDecoration: 'underline' }}
            role="button"
            tabIndex={-1}
            onKeyDown={onRemoveMenuItemModifier}
          >
            Remove
          </span>
          <span onClick={openModal} role="button" tabIndex={-1} onKeyDown={openModal}>
            Edit
          </span>
          {showModal && (
            <EditMenuItemModifierSet
              index={index}
              modifierSet={modifierSet}
              initialOpen={isNew}
              itemIndex={itemIndex}
              itemId={itemId}
              modifiers={modifierSetModifiers}
              onCreate={onCreate}
              onDelete={onRemoveMenuItemModifier}
              open={showModal}
              onOpen={openModal}
              onClose={closeModal}
            />
          )}
        </div>
      </Accordion.Title>
      <Accordion.Content active={active} className="modifier-set-modifiers">
        <List>
          {modifierSetModifiers.map(
            ({
              name: modifierName,
              price,
              priceDisplay,
              id: modifierId,
              localId: modifierLocalId,
            }) => (
              <List.Item key={modifierId || modifierLocalId}>
                <List.Content>{modifierName}</List.Content>
                <List.Content floated="right">{priceDisplay || `+$${price}`}</List.Content>
              </List.Item>
            ),
          )}
        </List>
      </Accordion.Content>
    </>
  );
}

MenuItemModifierSet.propTypes = propTypes;
MenuItemModifierSet.defaultProps = defaultProps;
